import { render } from "./ErrorLogs.vue?vue&type=template&id=23673235"
import script from "./ErrorLogs.vue?vue&type=script&lang=js"
export * from "./ErrorLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__